import type { HorizontalRuleNode } from '@blissbook/lib/document'
import type { NodeViewerComponent } from '.'

export const HorizontalRultNodeViewer: NodeViewerComponent = ({ node }) => {
  const horizontalRule = node as HorizontalRuleNode
  const { borderColor } = horizontalRule.attrs || {}
  return <hr style={{ borderColor }} />
}
